<script lang="ts" setup>
import SvgLoader from '@/utils/SvgLoader.vue';
import { RouterItem } from './interfaces/routerItems';
import { i18n } from '@/i18n';
import Mdi from '@/corePagesModule/components/Mdi.vue';

const props = defineProps<{
  routeItem: RouterItem;
}>();
</script>

<template>
  <div class="sidebar-item-container">
    <router-link :data-testid="routeItem.to == '/translate-excel' ? `sidebar-content_inventory_information` : ''" :to="routeItem.to">
      <div class="sidebar-item-content">
        <template v-if="routeItem.icon">
          <SvgLoader v-if="routeItem.icon.startsWith('sidebar-logo')" class="sidebar-item-content__icon-image" :name="routeItem.icon" />
          <Mdi v-else class="sidebar-item-content__icon-image" :icon="routeItem.icon" tag="div" />
        </template>
        <i18n-t class="sidebar-item-content__label-text i18n-break" :keypath="routeItem.name" tag="p">
          <template #newLine>
            <br />
          </template>
        </i18n-t>
      </div>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.sidebar-item-content {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: repeat(2, auto);
  align-content: space-evenly;
  place-items: center;

  &__icon-image {
    display: block;
    width: 24px;
    color: $textSecondary;
  }

  &__label-text {
    width: 100%;
    font: Noto Sans JP;
    font-size: $fontSizeSS;
    font-weight: 700;
    letter-spacing: 0;
    color: $textSecondary;
    white-space: pre-wrap;
    text-align: center;
  }
}

a {
  &:hover,
  &:focus,
  &:focus-visible {
    color: inherit !important;
    background-color: inherit !important;
  }
}
</style>
